export default "__VITE_ASSET__XOWo4lMU__"